module.exports = __webpack_public_path__ + "media/images/dot-e69b3bc4e25718d3004c7293c786dd78.png";